import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  paper: {
    minWidth: "660px",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
}))

export default styles
